import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const defaultStatus = {
  Pending: 0,
  "In Progress": 0,
  Completed: 0,
  Failed: 0,
};

const PieChart = ({ campaignStatus }) => {

  const statusCounts = { ...defaultStatus, ...campaignStatus };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "Properties sales monthly",
      },
    },
  };
  const data = {
    labels: ["Pending", "In Progress", "Completed", "Failed"],
    datasets: [
      {
        label: "# of Votes",
        data: [
          Number(statusCounts.Pending) || 0,
          Number(statusCounts["In Progress"]) || 0,
          Number(statusCounts.Completed) || 0,
          Number(statusCounts.Failed) || 0,
        ],

        backgroundColor: ["#fdd974", "#fcb7ba", "#56cbf1", "#f69898"],
        borderColor: ["#fdd974", "#fcb7ba", "#56cbf1", "#f69898"],
        borderWidth: 1,
      },
    ],
  };
  return <Pie data={data} options={options} />;
};

export default PieChart;
